import Food from "./food";
import { getDefaultFoodUnit } from "../utils/foodUtils";
import {
  AlternativeModificationDto,
  DishCreateDto,
  DishModificationDto,
  PersonChoiceModificationDto,
  StepIngredientCreateDto,
  StepIngredientModificationDto,
  StepModificationDto,
} from "../api";

export interface PersonRecipeUnitModification {
  id?: number;
  personId: number;
  amount: number;
}

export interface RecipeUnitModification {
  id: number;
  foodUnitId: number;
  foodId: number;
  portionAmount?: number;
  personRecipeUnitModificationDtos: PersonRecipeUnitModification[];
}

export interface PersonPortionAmount {
  personId: number;
  amount: number;
}

export type AlternativeModification = AlternativeModificationDto;

export type PersonChoiceModification = PersonChoiceModificationDto;

export type StepIngredientModification = StepIngredientModificationDto;

export type StepModification = StepModificationDto;

export type DishTag =
  | "lowCarb"
  | "highProtein"
  | "vegetarian"
  | "vegan"
  | "glutenFree"
  | "lowCalorie"
  | "lactoseFree";

export const DISH_TAG_LABELS: Record<DishTag, string> = {
  lowCalorie: "Kalorienarm",
  lowCarb: "Low Carb",
  highProtein: "High Protein",
  vegetarian: "Vegetarisch",
  vegan: "Vegan",
  glutenFree: "Glutenfrei",
  lactoseFree: "Laktosefrei",
};

export interface PersonDefaultPortion {
  personId: number;
  portions: number;
}

export type DishModification = DishModificationDto & {
  // Frontend-only fields (nicht ans Backend gesendet)
  fromCookbook?: boolean;
  recipePortions?: number;
  personDefaultPortions?: PersonDefaultPortion[];
};

export const emptyDish = (): DishModification => {
  return {
    purchaseRelevant: true,
    description: "",
    steps: [],
    vendor: "",
    fromCookbook: true,
    recipePortions: 1,
    personDefaultPortions: [],
    tags: [],
  };
};
export const emptyStep = (position: number): StepModification => {
  return {
    position,
    text: "",
    ingredients: [],
  };
};
export const emptyIngredient = (food: Food): StepIngredientModification => {
  return {
    alternatives: [],
    personChoices: [],
    foodUnitId: getDefaultFoodUnit(food)?.id,
    amount: 0,
  };
};
export const emptyDishCreate = (): DishCreateDto => {
  return {
    purchaseRelevant: false,
    description: "",
    vendor: "",
    ingredients: [],
  };
};
export const emptyCreateIngredient = (food: Food): StepIngredientCreateDto => {
  return {
    foodUnitId: getDefaultFoodUnit(food)?.id ?? -1,
    amount: 0,
  };
};
